module.exports = __webpack_public_path__ + "img/full1-min.9d674e64.png";